<template>
  <div>
    <!-- el carrusel de imagenes -->
    <Carrusel />

    <b-container>

      <h4 class="titulo-home">{{ parametros.frac_titulo }}</h4>
      <b-row>
        <b-col cols="3"></b-col>
        <b-col cols="6">
          <p class="text-muted titulo-home-descripcion">
            {{ parametros.frac_descripcion }}
          </p>
        </b-col>
      </b-row>
        

      <b-row class="mt-3 mb-5">
        <b-col cols="12" md="3">
          <Login />
        </b-col>
        <b-col cols="12" md="9">
          <!-- noticias -->
          <Noticia  v-for="noticia in noticias" :key="noticia.id_noticia"
            :idNoticia="noticia.id_noticia"
            :titulo="noticia.noticia"
            :imagen="noticia.imagen"
            :descripcion="noticia.contenido"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Carrusel from '@/components/Carrusel.vue'
import Noticia from '@/components/Noticia.vue'
import Login from '@/modules/colonos/components/Login.vue'
import axios from 'axios'
import {mapState} from 'vuex'

export default {
  name: 'Home',
  components: {
    Carrusel, Noticia, Login
  },
  data() {
    return {
      parametros: {},
      noticias: []
    }
  },
  created() {
    this.traerParametros()
    this.traerNoticias()
  },
  methods: {
    zfill(number, width) {
        var numberOutput = Math.abs(number); /* Valor absoluto del número */
        var length = number.toString().length; /* Largo del número */ 
        var zero = "0"; /* String de cero */  
        
        if (width <= length) {
            if (number < 0) {
                return ("-" + numberOutput.toString()); 
            } else {
                return numberOutput.toString(); 
            }
        } else {
            if (number < 0) {
                return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
            } else {
                return ((zero.repeat(width - length)) + numberOutput.toString()); 
            }
        }
    },
    traerParametros() {
      var formData = new FormData();
      formData.append("accion", "mostrarDatos");
      formData.append("tabla", "parametros");
      formData.append("limite", 1);
      
      axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
      .then((res) => {
          this.parametros = res.data
      });
    },
    traerNoticias() {
      // traemos las noticias mas recientes.
      var formData = new FormData();
      formData.append("accion", "mostrarDatos");
      formData.append("tabla", "vnoticias");
      formData.append("filtro", `vigencia >='${this.hoy}'`);
      formData.append("ordenamiento", `id_noticia desc`);
      formData.append("limite", 5);
      
      axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
      .then((res) => {
          this.noticias = res.data
      });
    }
  },
  computed: {
    hoy() {
        var fecha = new Date();
        var dia = fecha.getDate();

        var mes = fecha.getMonth();
        mes ++;
        
        var anio = fecha.getFullYear();
        
        return anio + '-' + this.zfill(mes, 2) + '-' + this.zfill(dia, 2);
    },
    url() {
        if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
            return this.urlSandbox
        } else {
            return this.urlProd
        }
    },
    ...mapState(['urlProd', 'urlSandbox', 'token'])
  }
}
</script>

<style socoped>
.titulo-home {
  margin-top: 50px;
  margin-bottom: 10px;
  color: #03224B;
  text-align: center
}

.titulo-home-descripcion {
  text-align: center;
  font-size: 12px;
  margin-bottom: 10px;
}
</style>